export const MantleSVG = () => (
    <svg
        width={138}
        height={40}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M50.9651 14.2402H46.124V25.7616H48.6206V16.7368H49.3386L53.3258 25.7616H56.0555L50.9651 14.2402Z"
            fill="white"
        />
        <path d="M94.5403 25.7616H97.0369V14.2402H94.5403V25.7616Z" fill="white" />
        <path
            d="M61.1452 14.2402L56.0553 25.7616H58.7845L62.7717 16.7368H63.4897V25.7616H65.9863V14.2402H61.1452Z"
            fill="white"
        />
        <path
            d="M77.151 14.2402H72.5836L67.4933 25.7616H70.2229L71.8813 22.0075H77.8533L79.5117 25.7616H82.2413L77.151 14.2402ZM72.9844 19.5109L74.2101 16.7368H75.5245L76.7501 19.5109H72.9844Z"
            fill="white"
        />
        <path
            d="M89.4501 14.2402H83.6848V25.7616H86.1814V16.7368H87.8236L91.8108 25.7616H94.5404L89.4501 14.2402Z"
            fill="white"
        />
        <path
            d="M98.4236 14.2402V16.7368H104.249V25.7616H106.746V16.7368H112.571V14.2402H98.4236Z"
            fill="white"
        />
        <path
            d="M116.455 14.2402H113.958V25.7616H124.823V23.265H116.455V14.2402Z"
            fill="white"
        />
        <path
            d="M138 16.7368V14.2402H126.21V25.7616H138V23.265H128.707V21.0828H136.763V18.5862H128.707V16.7368H138Z"
            fill="white"
        />
        <path
            d="M7.51717 14.5454L1.97885 11.7256C1.54564 12.5767 1.1767 13.4691 0.883118 14.378L6.79685 16.2902C6.99011 15.6924 7.23237 15.1057 7.51764 14.5458L7.51717 14.5454Z"
            fill="white"
        />
        <path
            d="M12.2217 9.57576L15.2893 14.8612C15.7373 14.6014 16.2168 14.4016 16.7156 14.2675L15.128 8.36583C15.532 8.25718 15.9426 8.16749 16.3555 8.1023L15.3799 1.96387C14.4363 2.11366 13.4987 2.33975 12.5925 2.63518L14.4895 8.44905C13.8861 8.64601 13.2985 8.89058 12.7326 9.18001L9.94425 3.73739C9.09633 4.17198 8.27615 4.67685 7.50543 5.23952L11.1694 10.2596C11.5069 10.0136 11.8597 9.78567 12.2213 9.5753L12.2217 9.57576Z"
            fill="white"
        />
        <path
            d="M28.683 13.9549L23.3994 17.0253C23.6597 17.4728 23.8594 17.9527 23.994 18.4507L29.8952 16.8602C30.0039 17.2643 30.0936 17.6744 30.1592 18.0868L36.2967 17.1094C36.1465 16.1663 35.9199 15.2282 35.6236 14.3216L29.8106 16.2222C29.6132 15.6189 29.3686 15.0317 29.0787 14.4658L34.5195 11.6738C34.0849 10.8268 33.5791 10.0066 33.0165 9.23633L27.9978 12.9027C28.2442 13.2402 28.4722 13.5925 28.6825 13.9545L28.683 13.9549Z"
            fill="white"
        />
        <path
            d="M26.5284 3.71251C25.6763 3.27977 24.784 2.91128 23.876 2.61816L21.967 8.53283C22.5643 8.72562 23.1515 8.96788 23.7123 9.25268L26.5284 3.71205V3.71251Z"
            fill="white"
        />
        <path
            d="M24.3216 9.46746L21.2189 14.8523C21.6683 15.1112 22.0825 15.4284 22.451 15.7954L31.1531 7.06377C30.4781 6.39107 29.7448 5.76646 28.9736 5.20703L25.3845 10.1568C25.0424 9.90899 24.6882 9.67828 24.3221 9.46699L24.3216 9.46746Z"
            fill="white"
        />
        <path
            d="M7.73299 13.9354L13.1164 17.0414C13.3753 16.5925 13.6934 16.1778 14.061 15.8088L5.33301 7.10352C4.65985 7.77853 4.03477 8.51133 3.47534 9.28204L8.42326 12.8735C8.17545 13.2151 7.94428 13.5693 7.73299 13.9354Z"
            fill="white"
        />
        <path
            d="M20.1462 7.99785L21.0852 1.95558C20.1573 1.81133 19.2077 1.73828 18.2622 1.73828H18.2479V14.066H18.2622C18.7819 14.066 19.296 14.1326 19.7907 14.2639L21.3848 8.25675C20.977 8.14857 20.5637 8.06304 20.1462 7.99785Z"
            fill="white"
        />
        <path
            d="M12.5261 18.4684L6.51986 16.8701C6.41121 17.2779 6.32522 17.6912 6.26003 18.1087L0.218685 17.1669C0.0735114 18.0981 0 19.0514 0 19.9997H12.3277C12.3277 19.4791 12.3948 18.9636 12.5265 18.4684H12.5261Z"
            fill="white"
        />
        <path
            d="M29.0074 25.4558L34.5457 28.2756C34.9789 27.4244 35.3478 26.5321 35.6414 25.6232L29.7277 23.7109C29.5344 24.3087 29.2922 24.8954 29.0069 25.4553L29.0074 25.4558Z"
            fill="white"
        />
        <path
            d="M24.3026 30.4241L21.235 25.1387C20.787 25.3985 20.3076 25.5982 19.8087 25.7323L21.3964 31.634C20.9918 31.7427 20.5817 31.8324 20.1689 31.8976L21.1439 38.0355C22.0876 37.8857 23.0252 37.6596 23.9314 37.3642L22.0344 31.5503C22.6382 31.3534 23.2254 31.1088 23.7913 30.8194L26.5796 36.262C27.4275 35.8274 28.2477 35.3225 29.0184 34.7599L25.3544 29.7398C25.0169 29.9858 24.6642 30.2137 24.3026 30.4241Z"
            fill="white"
        />
        <path
            d="M7.84183 26.0465L13.1259 22.9762C12.8656 22.5286 12.6658 22.0487 12.5313 21.5508L6.63005 23.1412C6.5214 22.7371 6.43171 22.327 6.36606 21.9146L0.228088 22.892C0.378348 23.8352 0.604892 24.7733 0.901249 25.6799L6.7142 23.7792C6.91161 24.3826 7.15619 24.9698 7.44608 25.5357L2.00531 28.3277C2.4399 29.1747 2.9457 29.9949 3.50836 30.7651L8.52702 27.0988C8.28059 26.7613 8.05266 26.409 7.8423 26.047L7.84183 26.0465Z"
            fill="white"
        />
        <path
            d="M9.99615 36.2882C10.8482 36.721 11.7405 37.0894 12.6486 37.3826L14.5576 31.4679C13.9602 31.2751 13.3731 31.0328 12.8122 30.748L9.99615 36.2887V36.2882Z"
            fill="white"
        />
        <path
            d="M12.2029 30.534L15.3057 25.1492C14.8563 24.8903 14.442 24.5731 14.0735 24.2061L5.37146 32.9377C6.04647 33.6104 6.77974 34.235 7.55091 34.7945L11.14 29.8447C11.4822 30.0925 11.8363 30.3232 12.2025 30.5345L12.2029 30.534Z"
            fill="white"
        />
        <path
            d="M28.7914 26.0659L23.4079 22.96C23.149 23.4089 22.8309 23.8236 22.4634 24.1925L31.1909 32.8983C31.8641 32.2233 32.4891 31.4905 33.0486 30.7198L28.1006 27.1284C28.3485 26.7867 28.5796 26.4326 28.7909 26.0664L28.7914 26.0659Z"
            fill="white"
        />
        <path
            d="M16.7338 25.7363L15.1397 31.7435C15.5475 31.8516 15.9608 31.9372 16.3783 32.0024L15.4398 38.0446C16.3677 38.1889 17.3173 38.2619 18.2628 38.2619H18.2771V25.9342H18.2628C17.7431 25.9342 17.229 25.8676 16.7343 25.7363H16.7338Z"
            fill="white"
        />
        <path
            d="M24.1969 20.001C24.1969 20.5216 24.1299 21.0366 23.9981 21.5322L30.0043 23.1305C30.113 22.7227 30.199 22.3094 30.2641 21.8919L36.306 22.8342C36.4511 21.903 36.5246 20.9497 36.5246 20.0014H24.1969V20.001Z"
            fill="white"
        />
    </svg>
);

export const MantleMediumSVG = () => (
    <svg
        width={40}
        height={40}
        viewBox="0 0 84 85"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M41.9876 84.4355L41.9931 70.199C40.5587 70.199 39.1131 70.0846 37.6981 69.8585L35.4896 83.9219C37.6315 84.2625 39.8179 84.4355 41.9904 84.4355H41.9876ZM48.4856 83.9275C50.6331 83.5869 52.7668 83.0761 54.831 82.4034L50.475 68.8591C49.1154 69.303 47.706 69.6407 46.2882 69.8641L48.4856 83.9275ZM29.1414 82.395L33.5085 68.8535C32.1462 68.4097 30.8116 67.8514 29.5381 67.1982L23.1067 79.8799C25.0405 80.8736 27.0715 81.7195 29.1414 82.395ZM60.8629 79.8966C62.7996 78.9056 64.6724 77.75 66.4315 76.4631L58.105 64.9511C56.948 65.7997 55.7161 66.559 54.4426 67.2094L60.8629 79.8966ZM17.5409 76.4408L25.8757 64.9343C24.7243 64.0913 23.6255 63.1422 22.6045 62.1177L12.5911 72.1782L12.5994 72.1866C14.1365 73.733 15.7985 75.1651 17.5409 76.4408ZM71.3147 72.2731L71.4007 72.1838C72.9323 70.6429 74.3529 68.9736 75.6236 67.2233L64.1896 58.835C63.3517 59.9906 62.4111 61.096 61.3957 62.1205L61.2542 62.2657L66.0652 66.8353L71.3147 72.2731ZM8.3571 67.1954L19.7966 58.8154C18.9532 57.6514 18.1985 56.412 17.5492 55.1307L4.94161 61.5929C5.92658 63.5386 7.07525 65.4228 8.3571 67.1926V67.1954ZM79.0447 61.6208C80.0324 59.6752 80.8731 57.6318 81.5473 55.5494L68.0879 51.1528C67.6468 52.5234 67.0918 53.8661 66.4426 55.1474L79.0447 61.6208ZM2.44727 55.5187L15.9095 51.1333C15.4683 49.7655 15.1326 48.3474 14.9078 46.9209L0.929588 49.1374C1.26808 51.298 1.7786 53.4446 2.44727 55.5215V55.5187ZM83.0678 49.1681C83.4063 47.0131 83.5783 44.8134 83.5811 42.6305L69.4308 42.6221C69.4308 44.0653 69.317 45.5196 69.0923 46.9461L83.0678 49.1681ZM14.5721 42.5998C14.5721 41.1566 14.6859 39.6994 14.9078 38.2758L0.929588 36.0593C0.591087 38.2143 0.421844 40.414 0.419067 42.597H14.5694L14.5721 42.5998ZM69.0978 38.2981L83.0761 36.09C82.7404 33.9294 82.2299 31.7828 81.564 29.7059L68.099 34.083C68.5402 35.4536 68.8759 36.8689 69.0978 38.2953V38.2981ZM15.9095 34.0662C16.3506 32.6956 16.9055 31.3501 17.552 30.0688L4.94438 23.6038C3.95941 25.5494 3.11872 27.5928 2.44727 29.6752L15.9067 34.0662H15.9095ZM66.4592 30.0884L79.0724 23.6345C78.0874 21.686 76.9388 19.8018 75.6597 18.032L64.2146 26.4064C65.0553 27.5705 65.81 28.8099 66.4592 30.0912V30.0884ZM19.8022 26.3841C20.6429 25.2228 21.5862 24.1118 22.6073 23.0874L22.635 23.0594L12.6299 12.9934L12.6022 13.0213C11.0651 14.5678 9.63895 16.2455 8.36543 18.0013L19.8022 26.3841ZM61.4456 23.1376L64.4671 20.0363L71.4229 13.0408L71.4007 13.0185C69.872 11.4804 68.2155 10.054 66.4787 8.77827L58.1383 20.2791C59.287 21.1222 60.3829 22.0657 61.3957 23.0874L61.4456 23.1376ZM25.909 20.2484C27.066 19.4026 28.2979 18.6433 29.5714 17.9929L23.1594 5.30288C21.2227 6.29386 19.3499 7.44673 17.5909 8.7336L25.909 20.2484ZM54.4787 18.0152L60.9184 5.33917C58.9846 4.34541 56.9564 3.4968 54.8865 2.82126L50.511 16.3599C51.8734 16.8065 53.2079 17.362 54.4814 18.018L54.4787 18.0152ZM33.5446 16.3432C34.9069 15.9021 36.3164 15.5643 37.7314 15.341L35.5423 1.27479C33.3975 1.61256 31.2611 2.1234 29.1968 2.79614L33.5446 16.3432ZM46.3242 15.3494L48.5383 1.28595C46.3964 0.945394 44.21 0.769531 42.0403 0.769531L42.0264 15.006C43.4609 15.006 44.9064 15.1233 46.3242 15.3494Z"
            fill="white"
        />
        <path
            d="M41.9958 70.8282V56.5199C40.8005 56.5199 39.608 56.3628 38.4548 56.057L34.7624 69.8799C37.1193 70.5083 39.5519 70.8282 41.9958 70.8282ZM49.2292 69.8799C51.5945 69.2486 53.87 68.3088 55.9856 67.0856L48.8252 54.6963C47.7954 55.2911 46.6899 55.7484 45.5395 56.0542L49.2292 69.8799ZM28.0031 67.0828L35.1664 54.6963C34.1395 54.1015 33.1883 53.3693 32.3353 52.5192L32.2035 52.3901L27.6833 57.1483L22.1362 62.5546L22.2175 62.6332C23.9515 64.367 25.8988 65.8623 28.0059 67.0828H28.0031ZM61.7741 62.6388H61.7769C63.508 60.9021 65.0036 58.9579 66.2213 56.8537L53.8364 49.6884C53.2415 50.7152 52.5092 51.6663 51.659 52.5164L61.7741 62.6388ZM17.7535 56.8229L30.1496 49.6744C29.5548 48.6447 29.1002 47.5393 28.7944 46.3863L14.9645 50.0643C15.593 52.4294 16.5329 54.7047 17.7535 56.8229ZM69.0215 50.1008C69.65 47.7441 69.9699 45.3117 69.9727 42.8681L55.663 42.8625C55.663 44.0605 55.5058 45.2528 55.1972 46.4059L69.0215 50.1008ZM28.3342 42.8457C28.3342 41.6477 28.4914 40.4553 28.8028 39.3023L14.9813 35.5989C14.35 37.9556 14.0273 40.388 14.0273 42.8316L28.337 42.8457H28.3342ZM55.2 39.3191L69.0271 35.6354C68.3958 33.2703 67.4558 30.995 66.2353 28.8797L53.842 36.0338C54.4368 37.0634 54.8942 38.1688 55.2 39.3191ZM30.1636 36.017C30.75 35.0042 31.4739 34.0643 32.3101 33.2226L32.3466 33.1862L27.2287 28.0689L22.3073 22.9936L22.2175 23.0806C20.4891 24.8088 18.9964 26.7475 17.7815 28.846L30.1636 36.017ZM27.2287 28.0661L27.2877 28.125L27.2287 28.0661ZM51.6675 33.203L56.7348 28.1362L61.9059 23.2097L61.7769 23.0778C60.0485 21.3496 58.104 19.8542 56.0025 18.6366L48.8336 31.0203C49.8465 31.6067 50.7892 32.3305 51.631 33.1665L51.6675 33.203ZM35.1748 31.0119C36.2018 30.4171 37.3073 29.9626 38.4604 29.654L34.7792 15.8283C32.4111 16.4595 30.1384 17.3966 28.02 18.6198L35.1748 31.0119ZM45.548 29.6596L49.2488 15.8367C46.892 15.2054 44.4593 14.8856 42.0154 14.8828L42.007 29.1911C43.2051 29.1911 44.3976 29.3482 45.5508 29.6568L45.548 29.6596Z"
            fill="white"
        />
    </svg>
);

export const SmallMantleSVG = () => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.4642 28.0514L4.33359 21.8752C3.38473 23.7395 2.57663 25.694 1.93359 27.6849L14.8865 31.8732C15.3098 30.5638 15.8404 29.2788 16.4652 28.0524L16.4642 28.0514Z"
            fill="white"
        />
        <path
            d="M26.7696 17.1675L33.4885 28.7442C34.4698 28.1751 35.5199 27.7376 36.6126 27.4439L33.1351 14.5174C34.0202 14.2794 34.9194 14.0829 35.8237 13.9402L33.687 0.495117C31.6202 0.823218 29.5665 1.31841 27.5817 1.96549L31.7366 14.6996C30.4151 15.131 29.128 15.6667 27.8885 16.3007L21.7812 4.37967C19.924 5.33156 18.1276 6.43738 16.4395 7.66979L24.4648 18.6652C25.204 18.1265 25.9767 17.6272 26.7685 17.1665L26.7696 17.1675Z"
            fill="white"
        />
        <path
            d="M62.8226 26.757L51.25 33.4821C51.8201 34.4623 52.2576 35.5135 52.5523 36.6041L65.4778 33.1206C65.7158 34.0056 65.9123 34.9039 66.056 35.8072L79.4991 33.6664C79.1699 31.6006 78.6737 29.5459 78.0246 27.5601L65.2925 31.7231C64.8601 30.4016 64.3244 29.1155 63.6895 27.876L75.6064 21.7606C74.6545 19.9054 73.5467 18.109 72.3143 16.4219L61.3219 24.4522C61.8616 25.1915 62.3609 25.9631 62.8216 26.756L62.8226 26.757Z"
            fill="white"
        />
        <path
            d="M58.1041 4.3242C56.2378 3.37636 54.2834 2.56927 52.2945 1.92725L48.1133 14.8822C49.4216 15.3044 50.7077 15.8351 51.9361 16.4589L58.1041 4.32319V4.3242Z"
            fill="white"
        />
        <path
            d="M53.2705 16.9293L46.4746 28.7237C47.4589 29.2908 48.3663 29.9855 49.1733 30.7895L68.2336 11.6645C66.7551 10.1911 65.149 8.82297 63.4599 7.59766L55.5986 18.4392C54.8493 17.8964 54.0736 17.3911 53.2716 16.9283L53.2705 16.9293Z"
            fill="white"
        />
        <path
            d="M16.9369 26.7145L28.7282 33.5175C29.2953 32.5342 29.992 31.6259 30.7971 30.8178L11.6802 11.7505C10.2058 13.229 8.83664 14.834 7.61133 16.5221L18.4488 24.3884C17.906 25.1368 17.3997 25.9125 16.9369 26.7145Z"
            fill="white"
        />
        <path
            d="M44.1267 13.7104L46.1834 0.475949C44.151 0.16 42.071 0 40.0001 0H39.9688V27.0015H40.0001C41.1384 27.0015 42.2644 27.1473 43.348 27.4349L46.8396 14.2774C45.9465 14.0405 45.0411 13.8531 44.1267 13.7104Z"
            fill="white"
        />
        <path
            d="M27.4359 36.645L14.2805 33.1443C14.0425 34.0375 13.8542 34.9428 13.7114 35.8572L0.478986 33.7944C0.161012 35.8339 0 37.922 0 39.999H27.0015C27.0015 38.8587 27.1483 37.7296 27.4369 36.645H27.4359Z"
            fill="white"
        />
        <path
            d="M63.5362 51.9485L75.6668 58.1247C76.6156 56.2604 77.4237 54.3059 78.0668 52.3151L65.1139 48.1267C64.6906 49.4361 64.16 50.7211 63.5352 51.9475L63.5362 51.9485Z"
            fill="white"
        />
        <path
            d="M53.2297 62.8318L46.5108 51.2551C45.5295 51.8242 44.4794 52.2617 43.3867 52.5554L46.8642 65.4819C45.9781 65.7199 45.0799 65.9164 44.1756 66.0591L46.3113 79.5032C48.3781 79.1751 50.4318 78.6799 52.4166 78.0328L48.2616 65.2986C49.5842 64.8673 50.8702 64.3316 52.1097 63.6976L58.2171 75.6186C60.0743 74.6667 61.8707 73.5609 63.5588 72.3285L55.5335 61.3331C54.7943 61.8718 54.0216 62.3711 53.2297 62.8318Z"
            fill="white"
        />
        <path
            d="M17.1764 53.2426L28.7501 46.5175C28.1799 45.5373 27.7425 44.4861 27.4478 43.3955L14.5223 46.879C14.2843 45.994 14.0878 45.0958 13.944 44.1925L0.5 46.3332C0.829113 48.399 1.32531 50.4537 1.97443 52.4395L14.7066 48.2765C15.139 49.598 15.6747 50.8841 16.3096 52.1236L4.39265 58.239C5.34455 60.0942 6.45239 61.8907 7.6848 63.5777L18.6772 55.5474C18.1374 54.8081 17.6382 54.0365 17.1774 53.2436L17.1764 53.2426Z"
            fill="white"
        />
        <path
            d="M21.8945 75.6759C23.7609 76.6238 25.7153 77.4309 27.7041 78.0729L31.8854 65.118C30.577 64.6957 29.291 64.1651 28.0626 63.5413L21.8945 75.6769V75.6759Z"
            fill="white"
        />
        <path
            d="M26.7267 63.0704L33.5226 51.276C32.5383 50.7089 31.631 50.0143 30.8239 49.2102L11.7637 68.3352C13.2422 69.8086 14.8482 71.1767 16.5373 72.4021L24.3986 61.5606C25.148 62.1033 25.9236 62.6087 26.7257 63.0714L26.7267 63.0704Z"
            fill="white"
        />
        <path
            d="M63.0614 53.285L51.27 46.4819C50.7029 47.4652 50.0062 48.3736 49.2012 49.1817L68.3171 68.25C69.7915 66.7715 71.1606 65.1665 72.3859 63.4784L61.5485 55.612C62.0913 54.8637 62.5976 54.088 63.0604 53.286L63.0614 53.285Z"
            fill="white"
        />
        <path
            d="M36.6537 52.563L33.1621 65.7204C34.0553 65.9574 34.9606 66.1447 35.875 66.2875L33.8193 79.5219C35.8517 79.8379 37.9317 79.9979 40.0026 79.9979H40.034V52.9964H40.0026C38.8644 52.9964 37.7383 52.8506 36.6548 52.563H36.6537Z"
            fill="white"
        />
        <path
            d="M52.9979 40.001C52.9979 41.1412 52.8511 42.2693 52.5625 43.3549L65.7179 46.8556C65.9559 45.9625 66.1442 45.0572 66.287 44.1427L79.5204 46.2065C79.8384 44.167 79.9994 42.0789 79.9994 40.002H52.9979V40.001Z"
            fill="white"
        />
    </svg>
);

export const MantleWordSVG = () => (
    <svg
        className="w-full h-auto opacity-10 mb-6"
        width={148}
        height={20}
        viewBox="0 0 148 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.570801 4.75124V0.703125H8.4248V0.703143L8.42481 0.703136L16.6839 19.3844H12.2558L5.78638 4.75124H4.62162V19.3845H0.570847V4.75124H0.570801ZM16.6839 19.3844L24.943 0.703136L24.943 0.70317V0.703125H32.797V0.703167H32.7977V19.3844H28.7469L28.7469 4.75124H27.5815L21.1127 19.3844H16.6839ZM79.1265 19.3844H83.1773V0.703167H79.1265V19.3844ZM44.1526 9.24911L46.1409 4.75124H48.2738L50.2624 9.24911H44.1526ZM39.6721 19.3844L42.363 13.2972H52.052L54.7432 19.3844H59.1713L50.913 0.703136L50.9128 0.703211V0.703125H43.5022V0.703542L35.2433 19.3844H39.6721ZM65.5633 4.75124V19.3844H61.5125V4.75124V0.703136L70.8668 0.703125V0.703426L70.8674 0.703136L79.1257 19.3844H74.6977L68.2282 4.75124H65.5633ZM85.4269 4.75124H94.5037V19.3844H98.5544V4.75124H107.631V0.703125H85.4269V4.75124ZM109.882 0.703136H113.932V15.3363H126.761V19.3844H109.882L109.882 19.3844V0.703136ZM133.061 11.798V15.3363H147.39V19.3844H129.011L129.01 19.3844V11.798V7.74987V4.75124V0.703136L147.389 0.703125V4.75124H133.061V7.74987H146.132V11.798H133.061Z"
            fill="white"
        />
    </svg>
);

export const EthereumSVG = () => (
    <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        role="img"
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title />
        <path d="M11.944 17.97L4.58 13.62 11.943 24l7.37-10.38-7.372 4.35h.003zM12.056 0L4.69 12.223l7.365 4.354 7.365-4.35L12.056 0z" />
    </svg>
);

export const ArrowDownSVG = () => (
    <svg
        id="accsvg8"
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 20 20"
        aria-hidden="true"
        className="h-5 w-5 text-white"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
        />
    </svg>
);

export const LineBreakSVG = () => (
    <svg
        viewBox="0 0 342 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="-mx-5"
    >
        <path
            d="M0 1H158.631C159.566 1 160.447 1.43589 161.015 2.17886L168.425 11.8792C169.626 13.451 171.992 13.451 173.193 11.8792L180.603 2.17885C181.171 1.43589 182.052 1 182.987 1H342"
            stroke="#2E524E"
        />
    </svg>
);

export const WarningSVG = () => (
    <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path d="M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
);

export const CloseSVG = () => (
    <svg
        id="closeMod"
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 24 24"
        className="cursor-pointer font-bold"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
);

export const ArrowForwardSVG = () => (
    <svg
        width={14}
        height={14}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.34903 6.40001L11.3494 6.40001L6.14983 1.20041L6.99943 0.349609L13.6738 7.00001L6.99943 13.6744L6.14983 12.7996L11.3494 7.60001L0.34903 7.60001L0.34903 6.40001Z"
            fill="white"
        />
    </svg>
);

export const HamburgerSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        aria-hidden="true"
        className="h-8 w-8 text-type-secondary hover:text-type-primary transition ease-in-out duration-300"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        />
    </svg>
);

export const SearchIconSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={16}
        viewBox="0 0 15 16"
        fill="none"
    >
        <path
            d="M12.959 14.833L8.25 10.145C7.792 10.5064 7.29567 10.7737 6.761 10.947C6.22633 11.1204 5.688 11.207 5.146 11.207C3.71533 11.207 2.5 10.714 1.5 9.72803C0.5 8.74203 0 7.5337 0 6.10303C0 4.68636 0.5 3.4747 1.5 2.46803C2.5 1.4607 3.71533 0.957031 5.146 0.957031C6.56267 0.957031 7.764 1.45703 8.75 2.45703C9.736 3.45703 10.229 4.67236 10.229 6.10303C10.229 6.67236 10.1457 7.2247 9.979 7.76003C9.81233 8.2947 9.54867 8.77703 9.188 9.20703L13.896 13.937C14.0213 14.0617 14.0803 14.211 14.073 14.385C14.0663 14.5584 14.0003 14.7077 13.875 14.833C13.7363 14.9717 13.5803 15.041 13.407 15.041C13.233 15.041 13.0837 14.9717 12.959 14.833ZM5.146 9.87403C6.188 9.87403 7.07333 9.50603 7.802 8.77003C8.53133 8.03403 8.896 7.14503 8.896 6.10303C8.896 5.0477 8.535 4.14836 7.813 3.40503C7.09033 2.66236 6.20133 2.29103 5.146 2.29103C4.07667 2.29103 3.174 2.66236 2.438 3.40503C1.702 4.14836 1.334 5.0477 1.334 6.10303C1.334 7.15903 1.702 8.05136 2.438 8.78003C3.174 9.50936 4.07667 9.87403 5.146 9.87403Z"
            fill="white"
        />
    </svg>
);